import axios from "axios";

export default {
  namespaced: true,
  state: {
    selectedAuthor: null,
    selectedInstitute: null
  },
  actions: {
    GET_AUTHORS: function ({commit, state}, search) {
      return axios.get(process.env.VUE_APP_API_URL + '/special/ueg/searchAuthors?' + search.query, {
        'headers': {
          'x-api-key': localStorage.getItem('x-api-key-ueg')
        }
      })
    },
    GET_AUTHOR: function ({commit, state}, search) {
      return axios.get(process.env.VUE_APP_API_URL + '/special/ueg/searchAuthors?crmid=' + search.id, {
        'headers': {
          'x-api-key': localStorage.getItem('x-api-key-ueg')
        }
      })
    },
  },
  mutations: {
    SET_SELECTEDAUTHOR: (state, {selectedAuthor}) => {
      state.selectedAuthor = selectedAuthor
    },
    SET_SELECTEDINSTITUTE: (state, {selectedInstitute}) => {
      state.selectedInstitute = selectedInstitute
    },
  },
  getters: {}
}
